import React, { Component, Fragment } from "react"
import PropTypes from "prop-types"
import { translate } from "react-i18next"
import styled from "styled-components"
import { formatNumberForDisplay } from "../utils/formatting-utils"

const OuterContainer = styled.div`
  height: 75px;
  color: black;
  text-align: center;
`

const IconContainer = styled.div`
  font-size: 14px;
  cursor: pointer;
`

// Singular comparison text, number and arrow
function ChartComparisonItem({
  columnCount,
  baseValue,
  comparisonValue,
  comparisonText,
  increaseIsGood,
  translateFn,
  translateText,
  usePercentage,
  showRealValue,
  onClick,
  appendText,
}) {
  const positiveColour = "green"
  const negativeColour = "red"
  let iconName
  let iconColour

  // Set the icon and its colour depending on the comparison value
  if (increaseIsGood) {
    if (comparisonValue < baseValue) {
      iconColour = positiveColour
      iconName = "mdi-arrow-up-bold"
    } else {
      iconColour = negativeColour
      iconName = "mdi-arrow-down-bold"
    }
  } else if (comparisonValue < baseValue) {
    iconColour = negativeColour
    iconName = "mdi-arrow-up-bold"
  } else {
    iconColour = positiveColour
    iconName = "mdi-arrow-down-bold"
  }

  if (comparisonValue === baseValue) {
    iconColour = "#333"
    iconName = "mdi-equal"
  }

  // Calculate the difference between the base value and the comparison
  let valueChange
  if (usePercentage) {
    // prettier-ignore
    valueChange = ((100 / comparisonValue) * baseValue) - 100 // eslint-ignore-line
  } else {
    valueChange = comparisonValue - baseValue
  }

  // Format the display value for the difference, e.g. "10%"
  const valueChangeFormatted = Math.round(valueChange)
  let comparisonValueFormatted = formatNumberForDisplay(Math.round(comparisonValue))

  let valueChangeText
  if (usePercentage) {
    valueChangeText = `${valueChangeFormatted}%`
  } else {
    valueChangeText = formatNumberForDisplay(valueChange)
  }

  valueChangeText = valueChangeText.replace("-", "")

  if (appendText) {
    valueChangeText = `${valueChangeText + appendText}`
    comparisonValueFormatted = `${comparisonValueFormatted + appendText}`
  }

  return (
    <div
      className={`col-lg-${columnCount} col-md-${columnCount}`}
      style={{ display: "inline-block" }}
    >
      {comparisonText && (
        <div>
          <span>{translateText && translateFn ? translateFn(comparisonText) : comparisonText}</span>
        </div>
      )}
      <IconContainer className="noselect" onClick={onClick}>
        {showRealValue ? (
          comparisonValueFormatted
        ) : (
          <Fragment>
            <i className={`mdi ${iconName}`} style={{ color: iconColour }} /> {valueChangeText}
          </Fragment>
        )}
      </IconContainer>
    </div>
  )
}

// The 'public' component
class ChartComparison extends Component {
  state = {
    showRealValues: false,
  }

  isMeaningfulValue = (value) => {
    return value || value === 0
  }

  toggleDisplay = () => {
    this.setState({ showRealValues: !this.state.showRealValues })
  }

  render() {
    const {
      t,
      baseValue,
      comparisonOneValue,
      comparisonOneText,
      comparisonTwoValue,
      comparisonTwoText,
      usePercentage,
      increaseIsGood,
      stack,
      translateText,
      appendText,
    } = this.props

    const columnCount = stack ? 12 : 6

    return this.isMeaningfulValue(baseValue) && this.isMeaningfulValue(comparisonOneValue) ? (
      <OuterContainer className="col-lg-12 col-md-12">
        <ChartComparisonItem
          baseValue={baseValue}
          columnCount={columnCount}
          comparisonValue={comparisonOneValue}
          comparisonText={comparisonOneText}
          increaseIsGood={increaseIsGood}
          translateText={translateText}
          translateFn={t}
          usePercentage={usePercentage}
          showRealValue={this.state.showRealValues}
          onClick={this.toggleDisplay}
          appendText={appendText}
        />
        {comparisonTwoValue && (
          <ChartComparisonItem
            baseValue={baseValue}
            columnCount={columnCount}
            comparisonValue={comparisonTwoValue}
            comparisonText={comparisonTwoText}
            increaseIsGood={increaseIsGood}
            translateText={translateText}
            translateFn={t}
            usePercentage={usePercentage}
            showRealValue={this.state.showRealValues}
            onClick={this.toggleDisplay}
            appendText={appendText}
          />
        )}
      </OuterContainer>
    ) : null
  }
}

ChartComparison.propTypes = {
  baseValue: PropTypes.number.isRequired,
  comparisonOneValue: PropTypes.number.isRequired,
  comparisonOneText: PropTypes.string.isRequired,
  comparisonTwoValue: PropTypes.number,
  comparisonTwoText: PropTypes.string,
  usePercentage: PropTypes.bool,
  increaseIsGood: PropTypes.bool, // Show a green up arrow if the comparison is greater than the base value
  stack: PropTypes.bool, // Whether to stack comparison one on top of two, or do side by side
  translateText: PropTypes.bool,
  t: PropTypes.func.isRequired,
  appendText: PropTypes.string,
}

ChartComparison.defaultProps = {
  comparisonTwoValue: null,
  comparisonTwoText: null,
  usePercentage: false,
  increaseIsGood: true,
  stack: false,
  translateText: false,
  appendText: null,
}

export default translate()(ChartComparison)



// WEBPACK FOOTER //
// ./src/components/ChartComparison.jsx